import React from "react";
import moment from "moment";
import { Comment, Image } from "semantic-ui-react";
import Highlight from "./Highlight";
import LikeButton from "./LikeButton";

const isOwnMessage = (message, user) => {
  return message.user.id === user.uid ? "message__self" : "";
};

const isImage = message => {
  //  console.log(message);
  return message.hasOwnProperty("image") && !message.hasOwnProperty("content");
};

const timeFromNow = timestamp => moment(timestamp).fromNow();

//改行、リンク対応
const editText = text => {
  const regExp = /(https?:\/\/\S+|\n)/;
  const regExpBr = /\n/;
  const regExpLink = /https?:\/\/\S+/;

  return text.split(regExp).map(function(line, i) {
    return line.match(regExpBr) ? (
      <br key={i} />
    ) : line.match(regExpLink) ? (
      <a target="_blank" href={line} key={i}>
        {line}
      </a>
    ) : (
      <Highlight key={i} textToHighlight={line} />
    );
  });
};

//各ファイル形式対応
const checkExtension = message => {
  if (
    message.image.indexOf(".jpg") !== -1 ||
    message.image.indexOf(".png") !== -1
  ) {
    return <Image src={message.image} className="message__image" />;
  } else {
    return editText(message.image);
  }
};

const Message = ({ message, user }) => (
  <Comment>
    <Comment.Avatar src={message.user.avatar} />
    <Comment.Content className={isOwnMessage(message, user)}>
      <Comment.Author as="a">{message.user.name}</Comment.Author>
      <Comment.Metadata>{timeFromNow(message.timestamp)}</Comment.Metadata>
      {isImage(message) ? (
        /* <Image src={message.image} className="message__image" /> */
        //各ファイル形式対応
        checkExtension(message)
      ) : (
        <Comment.Text>
          {/* 改行前のメッセージ1 */}
          {/* {message.content} */}
          {/* 改行前のメッセージ2 */}
          {/* {message.content.split("\n").map((m, key) => (
            <span key={key}>
              {m}
              <br />
            </span>
          ))} */}
          {editText(message.content)}
        </Comment.Text>
      )}
      <LikeButton message={message} user={user} />
    </Comment.Content>
  </Comment>
);

export default Message;



// WEBPACK FOOTER //
// ./src/components/Messages/Message.js